<template>
  <div
    class="bg-EXPONDO-secondary-light w-full px-5 lg:px-16"
    :class="sliderHeight"
  >
    <div
      class="w-full flex flex-col items-center lg:flex-row lg:gap-10"
      :class="{ slider: showContactInfo }"
    >
      <div
        v-if="showContactInfo"
        class="flex justify-center lg:justify-start items-center flex-wrap gap-x-4 text-EXPONDO-primary text-sm"
        :class="sliderHeight"
      >
        <PhoneNumber
          v-if="showPhoneNumber"
          :phone-number="contactInformation.phoneNumber"
          class="font-bold leading-4"
        />
        <div
          v-if="showWorkingHours"
        >
          <span>{{ contactInformation.openingHours }}</span>
        </div>
      </div>
      <TrustpilotDynamic
        class="lg:ml-auto"
        :class="sliderHeight"
      />
    </div>
  </div>
</template>

<script lang="ts">


export default defineComponent({
  name: 'TrustpilotHeader',

  props: {
    enableContactInfoInHeader: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {

    const { contactInformation } = useStoreVsfExtended();

    const showPhoneNumber = computed(() => !!contactInformation.value.phoneNumber);
    const showWorkingHours = computed(() => contactInformation.value.openingHours && showPhoneNumber.value);

    const showContactInfo = computed(() =>
      props.enableContactInfoInHeader && (showPhoneNumber.value || showWorkingHours.value),
    );

    const sliderHeight = 'h-8';

    return {
      showPhoneNumber,
      showWorkingHours,
      showContactInfo,
      sliderHeight,
      contactInformation,
    };
  
  },
});


</script>

<style lang="scss" scoped>
@use "~/assets/scss/helpers/_breakpoints" as breakpoints;
.slider {
  @keyframes listingSlider {
    0% {
      top: 0;
    }

    30% {
      top: 0;
    }

    50% {
      top: -100%;
    }

    80% {
      top: -100%;
    }

    100% {
      top: 0;
    }
  }

  position: relative;
  animation-name: listingSlider;
  animation-duration: 12s;
  animation-iteration-count: infinite;

  @include breakpoints.for-desktop {
    animation: none;
  }
}
</style>
